import { styled, Breakpoints } from '@vw-marketing/us-components';

export const ReviewsBarContainer: any = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  align-items: center;
  justify-content: left;
  padding-bottom: 30px;
  flex-flow: column;
  @media (min-width: ${Breakpoints.b560}px) {
    flex-flow: unset;
  }
`;
export const ReviewsPagesContainer: any = styled.div`
  width: 100%;
  height: 100%;
  padding-top: 50px;
`;
export const DropdownSectionContainer: any = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding-top: 22px;
  @media (min-width: ${Breakpoints.b560}px) {
    padding-top: 0;
  }
`;

export const SelectOption: any = styled.option``;

export const StyledRatingDropdownWrapper: any = styled.div`
  width: 100%;
  margin-right: 37px;

  @media (min-width: ${Breakpoints.b560}px) {
    margin-right: 80px;
  }
`;
export const StyledSortDropdownWrapper: any = styled.div`
  width: 100%;
`;

export const ReviewsContainer: any = styled.div``;

export const StyledHiddenPage: any = styled.div`
  display: flex;
  width: 100%;
`;
